import copy from 'copy-to-clipboard';
import ODAS from '@/utils/api/odas';
import resourceHelpers from '@/utils/helpers/resource';

export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?u=';

export const pageUrl = (sourceCode, path) => {
  if (!path) {
    path = window.location.pathname;
  }

  var baseUrl = window.location.protocol + '//' + window.location.host + path;

  if (baseUrl.match(/\/.+\?/)) {
    return baseUrl + '&p=' + sourceCode;
  } else {
    return baseUrl + '?p=' + sourceCode;
  }
};

export const openFacebookShare = () => {
  window.open(`${FACEBOOK_SHARE_URL}${encodeURI(window.location.href)}`, '_blank');
};

// Returns true when the link made it onto the clipboard, so callers know whether to toast.
export const copyShareLink = (resource) => {
  return copy(pageUrl('share-link', resourceHelpers.pathTo(resource)));
};

export const trackSharedResource = (track, resource, shareMethod) => {
  const resourceType = resource.resourceType || resource.resource_type;
  const payload = { share_method: shareMethod };

  switch (resourceType) {
    case 'Collection':
      payload.collection_id = resource.id;
      payload.collection_title = resource.title;
      break;
    case 'Organization':
      payload.organization_id = resource.id;
      payload.organization_title = resource.title;
      break;
    default:
      payload.opportunity_id = resource.id;
      payload.opportunity_title = resource.title;
      payload.organization_id = resource.organization?.id;
      payload.organization_slug = resource.organization?.slug;
  }

  track('Shared resource', payload);
};

/**
 * shareParams: Object containing
 *  String sender_full_name
 *  String recipient
 *  String format (email|sms)
 *  JSON String data A JSON string with resource data
 *  String invite_type (share_search_results|share_housing_helper_results|share_resource)
 *  String invite_value An identifier used to determine the uniqueness of the invitation
 */
const Sharer = {
  share: ({ shareParams, recaptchaResponse, locale }) => {
    //TODO [#6088] implement mixpanel tracking
    return ODAS.post('api/shares', {
      recaptcha_response: recaptchaResponse,
      share: shareParams,
      locale: locale
    });
  }
};

export default Sharer;
